import Vue from 'vue'
import Router from 'vue-router'

import auth from 'services/auth.js'
// import analytics from 'services/analytics.js'

import logScope from 'log-scope'
const log = logScope('router')

Vue.use(Router)

let toNext = ''

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/member',
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        requiresAuth: false,
        title: 'Logga in',
      },
    },
    {
      path: '/member',
      name: 'member',
      component: () =>
        import(/* webpackChunkName: "member" */ './views/member/'),
      meta: {
        requiresAuth: true,
        title: 'Medlem',
      },
    },
    {
      path: '/signup',
      name: 'signup',
      component: () =>
        import(/* webpackChunkName: "signup" */ './views/signup/'),
      meta: {
        title: 'Bli medlem',
      },
    },
    {
      path: '/verifyUser',
      name: 'verifyUser',
      props: (route) => ({
        uid: route.query.uid,
      }),
      component: () =>
        import(/* webpackChunkName: "verifyUser" */ './views/signup/verifyUser.vue'),
      meta: {
        title: 'Verifirera medlemskap',
      },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () =>
        import(/* webpackChunkName: "reset-password" */ './views/ForgotPassword.vue'),
      meta: {
        title: 'Glömt lösenord',
      },
    },
    {
      path: '*',
      redirect: '/logins',
    },
  ],
})

router.beforeEach((to, from, next) => {
  document.title =
    `${to.meta.title ? to.meta.title + ' | ' : ''}` +
  'My Equardian'

  // eslint-disable-next-line
  const currentUser = auth.getUser()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // Dynamic page tracking for Google Analytics
  if (typeof from.name === 'string' && from.name.length > 0) {
    // log.success('Logging to GA, path: ' + to.path)
    // analytics.pageView(to.path)
  }

  if (requiresAuth && !currentUser) {
    log.danger('Redirecting not logged in user to Login')
    // toNext = to
    next({ path: '/login' })
    return
    // eslint-disable-next-line brace-style
  } else if (toNext !== '') {
    let toNextCopy = toNext
    toNext = ''
    next(toNextCopy)
  }

  // later when we have a profil page and want to show a special page for logged in users

  // else if (!requiresAuth && currentUser) next('home')

  next()
})

export default router
